/* global ADV */

import * as actions from './Actions';

const initialState = {
  currentRoute: {
    isReactRoute: false,
    controller: null,
    params: {},
    clientId: null,
    pageName: ADV.info.Demo ? null : 'Dashboard',
  },
};

export default (state = initialState, { type, ...action }) => {
  switch (type) {
    case actions.SET_CURRENT_ROUTE:
      return { ...state, currentRoute: action.currentRoute };
    default:
      return state;
  }
};
